const Blockly = require('blockly');
const dataAccessMethods = require('../../../../dataAccessMethods');
const mdcConfig = require('@sstdev/lib_metadata-config');
const setupAddCodeProperties = require('../../../../helpers/addCodeProperties');
const { config } = mdcConfig;

const TOOLTIP = 'Displays a block of fixed text, optionally with an icon next to it.';

/**
 * @param {*} color
 * @param {import('blockly').Block} blocklyBlock
 */
function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {
    blocklyBlock.setTooltip(TOOLTIP);
    // the main text is in `title`, handles centrally
    line1OfInputs.appendField('  Font Size:').appendField(new Blockly.FieldNumber(14), 'fontSize').appendField('px');
    line1OfInputs.appendField('  Icon Name:').appendField(new Blockly.FieldTextInput(''), 'iconName');

    const line2OfInput = blocklyBlock.appendDummyInput().setAlign(Blockly.ALIGN_RIGHT);
    const sizeDropDown = new Blockly.FieldDropdown(config.textSizes);
    sizeDropDown.setValue('sm');
    const weightDropDown = new Blockly.FieldDropdown(config.textStyles);
    weightDropDown.setValue('regular');

    line2OfInput.appendField('  Text Size:').appendField(sizeDropDown, 'textSize');
    line2OfInput.appendField('  Text Weight:').appendField(weightDropDown, 'textWeight');
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function convertCustomFieldsToCode(code, blocklyBlock) {
    // the main text is in `title`, handles centrally
    const addCodeProperties = setupAddCodeProperties(code, blocklyBlock);
    addCodeProperties(['fontSize', 'iconName', 'textSize', 'textWeight']);
    return code;
}

/**
 * @param {{[key: string]: any}} code
 * @param {import('blockly').Block} blocklyBlock
 * @return {{[key: string]: any}}
 */
function asDataDictionary(hNode) {
    // a paragraph of text does not contribute to any data formats
    return [{}, {}];
}
module.exports = { addBlockSpecificFields, convertCustomFieldsToCode, asDataDictionary };
